import { JxtTagColorsEnum } from '@jooxter/utils';

export const availabilityToneClasses: Record<JxtTagColorsEnum, { text: string; dot: string }> = {
  [JxtTagColorsEnum.GREEN]: { text: 'text-green-140', dot: 'bg-green-100' },
  [JxtTagColorsEnum.ORANGE]: { text: 'text-orange-140', dot: 'bg-orange-100' },
  [JxtTagColorsEnum.RED]: { text: 'text-red-140', dot: 'bg-red-100' },
  [JxtTagColorsEnum.BLUE]: { text: 'text-primary-140', dot: 'bg-primary-100' },
  [JxtTagColorsEnum.NEUTRAL]: { text: 'text-neutral-100', dot: 'bg-neutral-60' },
};
